import { ClockCounterClockwise } from '@phosphor-icons/react'
import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'
import { formatUpdatedAt } from '../lib/constants'

const actionLabel = { create: '建立', update: '更新', delete: '刪除', restore: '還原' }

export function HistoryPanel({ entity, id }: { entity: string; id?: string }) {
  const history = useQuery({ queryKey: ['audit', entity, id], queryFn: () => api.auditHistory(entity, id!), enabled: Boolean(id) })
  if (!id) return null
  return <details className="history-panel"><summary><ClockCounterClockwise size={18} />修改紀錄</summary><div className="history-list">{history.isLoading ? <p>載入紀錄中…</p> : null}{history.data?.map((entry) => <article key={entry.id}><span className={`history-action action-${entry.action}`}>{actionLabel[entry.action]}</span><div><strong>{entry.changedByName || 'System'}</strong><small>{formatUpdatedAt(entry.createdAt)}</small>{entry.action === 'update' ? <p>{describeChanges(entry.beforeJson, entry.afterJson)}</p> : null}</div></article>)}{history.data?.length === 0 ? <p>目前沒有修改紀錄。</p> : null}</div></details>
}

function describeChanges(beforeJson: string | null, afterJson: string | null) {
  try {
    const before = beforeJson ? JSON.parse(beforeJson) as Record<string, unknown> : {}
    const after = afterJson ? JSON.parse(afterJson) as Record<string, unknown> : {}
    const changed = Object.keys(after).filter((key) => key !== 'version' && JSON.stringify(before[key]) !== JSON.stringify(after[key]))
    const labels: Record<string, string> = {
      projectName: 'Project', projectNames: 'Project', projectIds: '關聯 Project', readinessItemIds: '關聯 Test Item',
      workingItemIds: '關聯 Working Item', riskType: '類型', title: '標題', owner: 'Owner', description: '描述',
      impactDescription: '影響', probability: '發生機率', impactLevel: '影響程度', mitigation: '預防／降低措施',
      contingency: '應變方案', nextReviewDate: '下次檢視日期', closed: '已關閉', closureNote: '結案說明', links: '參考連結', notes: '備註',
    }
    return changed.length ? `變更欄位：${changed.map((key) => labels[key] ?? key).join('、')}` : '版本或排序更新'
  } catch { return '內容已更新' }
}
